<template>
  <Modal
    v-model="_value"
    width="400"
    title="设备配件绑定安装维修员"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form v-if="positioningDeviceFittingList.length > 0" ref="loginForm" :model="positioningDeviceFittingList">
      <div v-for="item in positioningDeviceFittingList">
        <FormItem prop="encryptionChipNumber" label="配件信息">
          <label style="display: inline-block;">{{item.encryptionChipNumber}}</label>
          <label style="display: inline-block;">{{item.positioningDeviceFittingsType.name}}</label>
        </FormItem>
      </div>
      <FormItem prop="name" label="安装员">
        <Select class="field" v-model="positioningDeviceFitting.installerId">
          <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
    <Form v-else ref="loginForm" :model="positioningDeviceFitting">
      <FormItem prop="name" label="安装员">
        <Select class="field" v-model="positioningDeviceFitting.installerId">
          <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'positioningdevicefittingchangeinstallermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      installers: [],
      positioningDeviceFitting: {
        id: null,
        installerId: null
      },

      positioningDeviceFittingList: [],
      positioningDeviceFittingIds: []
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceFittingServ_GetDetail',
      'PositioningDeviceFittingServ_ChangeInstaller',
      'PositioningDeviceFittingServ_BatchChangeInstaller'
    ]),
    onOk () {
      if (this.positioningDeviceFittingList != null && this.positioningDeviceFittingList.length > 0) {
        store.dispatch('PositioningDeviceFittingServ_BatchChangeInstaller', {
          params:
            {
              ids: this.positioningDeviceFittingIds,
              installerId: this.positioningDeviceFitting.installerId
            },
          urlparams: null
        }).then(() => {
          this.$Message.success('绑定安装员成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '指派安装员',
          content: '<p>确认绑定安装员</p>',
          onOk: () => {
            store.dispatch('PositioningDeviceFittingServ_ChangeInstaller', {
              params: {
                id: this._initValue,
                installerId: this.positioningDeviceFitting.installerId
              }
            }).then(() => {
              this.$Message.success('绑定安装员成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        console.log(this._listValue)
        this.positioningDeviceFittingList = this._listValue
        this.positioningDeviceFittingIds = []
        if (this.positioningDeviceFittingList != null && this.positioningDeviceFittingList.length > 0) {
          this.positioningDeviceFittingList.forEach(item => {
            this.positioningDeviceFittingIds.push(item.id)
          })
        } else {
          this.positioningDeviceFittingIds = []

          this.positioningDeviceFitting.id = null
          this.positioningDeviceFitting.installerId = null

          let positioningDeviceFittingId = this._initValue
          if (positioningDeviceFittingId) {
            store.dispatch('PositioningDeviceFittingServ_GetDetail', {
              params: { id: positioningDeviceFittingId }
            }).then(() => {
              this.positioningDeviceFitting = store.getters.get_PositioningDeviceFitting_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          let installers = []
          store.getters.get_User_GetAllUsersResult.forEach(item => {
            if (item.state === 1) {
              installers.push(item)
            }
          })
          this.installers = installers
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
